// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"02389010","284":"1f2d7f9e","455":"b53077cf","626":"142d02f9","651":"ada9af09","725":"66f073e4","977":"72ee9d44"}[chunkId] + ".chunk.js";
};